import { createApi } from '@reduxjs/toolkit/query/react';
import { createAppBaseQuery } from '../../services/baseQuery';

export const alertsApi = createApi({
  reducerPath: 'alertsApi',
  baseQuery: createAppBaseQuery(),
  tagTypes: ['Alerts'],
  endpoints: (builder) => ({
    listAlerts: builder.query({
      query: () => '/alerts',
      providesTags: ['Alerts'],
    }),
    createAlert: builder.mutation({
      query: (body) => ({ url: '/alerts', method: 'POST', body }),
      invalidatesTags: ['Alerts'],
    }),
    updateAlert: builder.mutation({
      query: ({ publicId, ...body }) => ({ url: `/alerts/${publicId}`, method: 'PATCH', body }),
      invalidatesTags: ['Alerts'],
    }),
    deleteAlert: builder.mutation({
      query: (publicId) => ({ url: `/alerts/${publicId}`, method: 'DELETE' }),
      invalidatesTags: ['Alerts'],
    }),
  }),
});

export const {
  useListAlertsQuery,
  useCreateAlertMutation,
  useUpdateAlertMutation,
  useDeleteAlertMutation,
} = alertsApi;
